













import { Prop, Component, Vue, Provide } from 'vue-property-decorator';

import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import PatientFileBanner from '@/components/patients/file/PatientFileBanner.vue';
import PatientFilePathology from '@/components/patients/file/PatientFilePathology.vue';
import PatientFileBodyInformations from '@/components/patients/file/PatientFileBodyInformations.vue';
import PatientFileLastAnalysisInformations from '@/components/patients/file/PatientFileLastAnalysisInformations.vue';
import PatientFileContact from '@/components/patients/file/PatientFileContact.vue';

// Dialog components
import PatientAddOrEdit from '@/components/patients/PatientAddOrEdit.vue';
import PatientDelete from '@/components/patients/PatientDelete.vue';
import PatientPathologyAddOrEdit from '@/components/patients/PatientPathologyAddOrEdit.vue';

@Component({
  components: {
    PatientFileBanner,
    PatientFilePathology,
    PatientFileBodyInformations,
    PatientFileLastAnalysisInformations,
    PatientFileContact,
    PatientPathologyAddOrEdit,
    PatientAddOrEdit,
    PatientDelete,
  },
})
export default class PatientFile extends Vue {
  @Prop({ required: true }) private readonly patient!: TEntity<TPatient>;
}
